import { REWARD_TYPES } from './CurrentDocument';


export default REWARD_TYPES;
